<script>
export default {
  props: {
    aulive: Object,
  },
  data() {
    return {
      modal: false,
      linkCopiado: false,
    };
  },
  methods: {
    handler() {
      this.modal = true;
      this.$refs.alunos.handler();
    },
    copiar() {
      // Copia o conteúdo para a área de transferência
      navigator.clipboard
        .writeText(this.aulive.link_lt)
        .then(() => {
          // Exibe o alerta
          this.linkCopiado = true;
          // Oculta o alerta após 5 segundos
          setTimeout(() => {
            this.linkCopiado = false;
          }, 2000);
        })
        .catch((err) => {
          this.$log.debug("Erro ao copiar para a área de transferência:", err);
        });
    },
  },
};
</script>
<template>
  <div>
    <b-modal
      v-model="modal"
      size="lg"
      :title="'Aulive ' + aulive.descricao"
      title-class="font-18"
      hide-footer
    >
      <form>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <div role="group" class="form-group mb-3">
                <label class="d-block">Dia</label>
                <div>
                  <input type="text" class="form-control" :value="aulive.data" readonly />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <div role="group" class="form-group mb-3">
                <label class="d-block">Início</label>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    :value="aulive.hora_ini"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <div role="group" class="form-group mb-3">
                <label class="d-block">Fim</label>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    :value="aulive.hora_fim"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md">
          <div class="form-group">
            <div role="group" class="form-group mb-3">
              <label class="d-block">Link</label>
              <div>
                <textarea
                  rows="7"
                  class="form-control"
                  :value="aulive.link_lt"
                  readonly
                  cols=""
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="button-items">
        <b-button variant="info" :href="aulive.link_lt" target="_blank">
          <i class="bx bx-link-external font-size-16 align-middle"></i>
          Acessar Aulive
        </b-button>
        <b-button variant="success" @click="copiar">
          <i
            :class="
              'bx ' +
              (linkCopiado ? 'bx-check' : 'bx-copy') +
              ' font-size-16 align-middle'
            "
          ></i>
          {{ linkCopiado ? "Link Copiado" : "Copiar Link" }}
        </b-button>
        <b-button variant="secondary" @click="modal = false" class="ml-auto">
          <i class="bx bx-x font-size-16 align-middle"></i>
          Fechar
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
